var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-587.945 -150.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    transform: "translate(587.945 150.945)",
    fill: "#ffb743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,49a8.559,8.559,0,0,1-8.559-8.559H62.357A8.559,8.559,0,0,1,53.8,49ZM33.613,35.458l-1.705,0v-.007L4.5,35.4.085,10.459A2.286,2.286,0,0,1,0,9.842,2.394,2.394,0,0,1,2.433,7.489a2.468,2.468,0,0,1,1.686.657l11.92,8.734a3.427,3.427,0,0,0,4.9-.441c2.309-2.631,10.6-15.331,10.6-15.331h.011a2.476,2.476,0,0,1,4.163.055c.588.905,8.279,12.746,10.48,15.276a3.379,3.379,0,0,0,4.855.441L62.839,8.186a2.464,2.464,0,0,1,1.728-.7A2.394,2.394,0,0,1,67,9.842a2.32,2.32,0,0,1-.039.421l.009,0L62.493,35.4l-27.16.056v.007Z",
    transform: "translate(624.945 196.945)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5046ed2ec39ce10611fcefd8efb34076.svg";
export { ForwardRef as ReactComponent };